export const capitalizeText = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1)
}

export const getRowColor = (colors, darkmode, index) => {
    if (darkmode) {
        return index % 2 === 0 ? colors.main_table_row_color_dark : 'inherit'
    } else {
        return index % 2 === 0 ? colors.main_table_row_color_light : 'inherit'
    }
}

export const sortData = (data, parameter) => {
    const sortedData = [...data]
    return sortedData.sort((a, b) => (a[parameter] > b[parameter] ? 1 : -1))
}
